import styles from './styles.module.css';
import React, { ReactElement } from 'react';

interface SectionWithHeaderProps {
    chartTitle?: string;
    title?: string;
    headerImage?: string;
    subTitle?: string;
    isWeb?: boolean;
    scoreChart?: ReactElement;
    children: ReactElement;
    subtitleIcon?: string;
    hasHeader: boolean;
    handleInfoDetails?: () => void;
}

const SectionWithHeader = (props: SectionWithHeaderProps) => {
    const {
        title,
        subTitle,
        scoreChart,
        children,
        headerImage,
        subtitleIcon,
        hasHeader,
        chartTitle,
        isWeb,
        handleInfoDetails,
    } = props;

    return (
        <>
            {hasHeader && !!title && (
                <div
                    className={`${styles.header} ${styles.headerSmallerMargin}`}>
                    <img src={headerImage} alt="illustration" />
                    <h1>{title}</h1>
                </div>
            )}
            {(!!subTitle ||
                !!chartTitle ||
                !!subtitleIcon ||
                (isWeb && !!handleInfoDetails)) && (
                <div className={styles.scoreExplanationTitle}>
                    {!!subTitle && (
                        <h2
                            className={`${styles.textSubtitle} ${styles.textNoAboveSpace}`}>
                            {subTitle}
                        </h2>
                    )}
                    {!!chartTitle && <h3>{chartTitle}</h3>}
                    {!!subtitleIcon && (
                        <img
                            src={subtitleIcon}
                            alt="report page subtitle icon"
                        />
                    )}
                    {isWeb && !!handleInfoDetails && (
                        <span
                            className={`${styles.infoIcon}`}
                            onClick={handleInfoDetails}>
                            ?
                        </span>
                    )}
                </div>
            )}
            {(!!scoreChart || !!children) && <div className={styles.scoreContainer}>
                {!!scoreChart && (
                    <div className={`${styles.scoreContainerChartWrap}`}>
                        {scoreChart}
                    </div>
                )}
                {!!children && <div className={styles.scoreContainerExplanation}>
                    {children}
                </div>}
            </div>}
        </>
    );
};

export default SectionWithHeader;
